import apiService from "../common/utils/apiService";
import * as providerActions from "../slices/providerSlice";

const PROVIDER_URL = `/providers`;
const STORAGE_URL = `/storageEndpoints`;


export const getProviders = () => async (dispatch) => {
    dispatch(providerActions.getProvidersRequest());
    try {
        let url = PROVIDER_URL;
        const response = await apiService.get(url, null, {});
        if (response) {
            dispatch(providerActions.getProvidersSuccess(response));
        }
    } catch (error) {
        dispatch(providerActions.getProvidersFailure());
        console.error('Error fetching providers:', error);
    }
}

export const getStorageEndpoints = () => async (dispatch) => {
    dispatch(providerActions.getStorageEndpointsRequest());
    try {
        let url = STORAGE_URL;
        const response = await apiService.get(url, null, {});
        if (response) {
            dispatch(providerActions.getStorageEndpointsSuccess(response));
        }
    } catch (error) {
        dispatch(providerActions.getStorageEndpointsFailure());
        console.error('Error fetching storageEndpoints:', error);
    }
}